import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/1dde86ed/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Rapidly create wireframes, interactive prototypes, and documentation in Axure RP. The Carbon Axure kit contains the resources you need to get started.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Get the kit</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Start designing</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Support</AnchorLink>
    </AnchorLinks>
    <h2>{`Get the kit`}</h2>
    <h4>{`1. Install Axure RP.`}</h4>
    <p>{`To design with the Carbon Axure Kit you must have the latest version of `}<a parentName="p" {...{
        "href": "https://www.axure.com/download"
      }}>{`Axure RP`}</a>{` installed.`}</p>
    <h4>{`2. Get the widget library.`}</h4>
    <p>{`The library contains the widgets for Carbon components, design elements, and other common shapes.`}</p>
    <p>{`Download the `}<inlineCode parentName="p">{`.rplib`}</inlineCode>{` file to your computer. Open Axure and click the Add Library `}<inlineCode parentName="p">{`+`}</inlineCode>{` icon at the top of the Libraries pane. Locate and select the `}<inlineCode parentName="p">{`IBM Carbon 10.rplib`}</inlineCode>{` file.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Get the Axure widget library" href="https://github.com/IBM/design-kit/blob/master/Axure/IBM%20Carbon%2010.rplib?raw=true" actionIcon="download" mdxType="ResourceCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "245px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100.40816326530613%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAADxklEQVQ4y61Uz2tdRRS+9R+otuDOjUvThYK4E+zCP0BcFLQIEhdSpIL1F0UsSJNaRYn2B3ZRrCBWUVcB0URp0DTWpBhIaZoXsYlp2rz37rs/587MnZn75vOcecnTRRcuvI+Pe96Z831zzjfzXhTRI4Q4YoxZc84lhNha12NQfFdYZ2ndchwzh7h/kcbrrBWVFOB/eqqqejOq63qLvzT9viN4wHt+++2YkhQO0PQbD/r4vh/GTcj3HWtordcipbVlrnNUQArrm7l/ceIKnrtwDX/EklOwroFrAgeJbOOTq0fw/uXnsZ4tBw6t8Rs0to6UUoY2ZJKnrZEXCs+8O4v7X7uEpy+ukFCDhmCdY21cWHwbL0zuw7GZp0i8A6J4WguCZJ+KJAlSy9Sh87UddLG0nuHR8TnsHp/HO7O32RCgD8xvfo+XvnsMr07tx/XOlVBrrOHNPCuWZamiSsogyEnuQhsbxjw3ewt7SfC+U0v4YS0L5I3sJt748Ul8uzwRvtcDMdCNYFtR7AjyWMZaT8AOQD4f/GYV0Xu/46HPV7EldBBpxYtIZUw2ePyrng7Gk12FikRVGTa9Nv8IKmOC4M1E4uFPbyCaWMKzU7fgqKN+w2NyvRkKUswnPRAsBQu6kOSiHZS6Bhs39usd7Pr4GqKz13FpowBcDUlr1MCwVhOXp8zynAWF4V10bTyBFwPBNxatrsDI+eXQ4cHpDdi6hqYD0tSp5pjF6hB7S4IpCxalMDWPSUkuUtuwVHzgq1bwcIQ8bBeS7zHE4gZUUkI74uhhfTjQNMtUlJel4Z3ognsuEJLNdzg1s449Y/PYe3oJ03+m4eoUrTbifSeRj0+Bq1SlgqgkLvmGJGXBggRrE5JCKrLN4rdWF48cn8O9JxYwdnkz+FaSn8UXV9Hd8xa6Dx5H+dMKFHUsKxm4PGUvTVWUFYXhtknMa1MjyQVGP5zDA0d/xoEvV8gfDbr8qGgz6QzSQ1+ju/soek+cRrWVhlxVSc/3t5eQIBlp+BBKSjpa/Oj8AkZGJ/H4B/NY7RTkpUZJYkRCReuinaG3/ww60StIRi+i6lsvWJCmjJNERUmW24o6KKUkD5WfnG7h2GeLmLnRQUOj5iQkJENBlBUE+VssrCGhTrOzv3hBHBbkprq9no6SPO8NOqwa7tI2NR2m8abWPheV59wQtGnJOVt7gT7BDXLEDSOn2WbU7sZj/JPiX0elNYTiEQdvqeu7g9fohCVbQRw+A346vd44/2nvasfxCRr9dpoXGSHdfv9n0JR3OnF88vDhl+/5G7aysgz8Lxh0AAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "axure icon",
              "title": "axure icon",
              "src": "/static/e878c89184e7e02b36a7c03481bb8d0a/36382/axure-icon.png",
              "srcSet": ["/static/e878c89184e7e02b36a7c03481bb8d0a/36382/axure-icon.png 245w"],
              "sizes": "(max-width: 245px) 100vw, 245px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </ResourceCard>
      </Column>
    </Row>
    <br />
    <h4>{`3. Download the template.`}</h4>
    <p>{`This Axure file has the settings that are required for the proper display of elements.`}</p>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Get the Axure template" href="https://github.com/IBM/design-kit/blob/master/Axure/ibm-carbon-template.rp?raw=true" actionIcon="download" mdxType="ResourceCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "245px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100.40816326530613%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAADxklEQVQ4y61Uz2tdRRS+9R+otuDOjUvThYK4E+zCP0BcFLQIEhdSpIL1F0UsSJNaRYn2B3ZRrCBWUVcB0URp0DTWpBhIaZoXsYlp2rz37rs/587MnZn75vOcecnTRRcuvI+Pe96Z831zzjfzXhTRI4Q4YoxZc84lhNha12NQfFdYZ2ndchwzh7h/kcbrrBWVFOB/eqqqejOq63qLvzT9viN4wHt+++2YkhQO0PQbD/r4vh/GTcj3HWtordcipbVlrnNUQArrm7l/ceIKnrtwDX/EklOwroFrAgeJbOOTq0fw/uXnsZ4tBw6t8Rs0to6UUoY2ZJKnrZEXCs+8O4v7X7uEpy+ukFCDhmCdY21cWHwbL0zuw7GZp0i8A6J4WguCZJ+KJAlSy9Sh87UddLG0nuHR8TnsHp/HO7O32RCgD8xvfo+XvnsMr07tx/XOlVBrrOHNPCuWZamiSsogyEnuQhsbxjw3ewt7SfC+U0v4YS0L5I3sJt748Ul8uzwRvtcDMdCNYFtR7AjyWMZaT8AOQD4f/GYV0Xu/46HPV7EldBBpxYtIZUw2ePyrng7Gk12FikRVGTa9Nv8IKmOC4M1E4uFPbyCaWMKzU7fgqKN+w2NyvRkKUswnPRAsBQu6kOSiHZS6Bhs39usd7Pr4GqKz13FpowBcDUlr1MCwVhOXp8zynAWF4V10bTyBFwPBNxatrsDI+eXQ4cHpDdi6hqYD0tSp5pjF6hB7S4IpCxalMDWPSUkuUtuwVHzgq1bwcIQ8bBeS7zHE4gZUUkI74uhhfTjQNMtUlJel4Z3ognsuEJLNdzg1s449Y/PYe3oJ03+m4eoUrTbifSeRj0+Bq1SlgqgkLvmGJGXBggRrE5JCKrLN4rdWF48cn8O9JxYwdnkz+FaSn8UXV9Hd8xa6Dx5H+dMKFHUsKxm4PGUvTVWUFYXhtknMa1MjyQVGP5zDA0d/xoEvV8gfDbr8qGgz6QzSQ1+ju/soek+cRrWVhlxVSc/3t5eQIBlp+BBKSjpa/Oj8AkZGJ/H4B/NY7RTkpUZJYkRCReuinaG3/ww60StIRi+i6lsvWJCmjJNERUmW24o6KKUkD5WfnG7h2GeLmLnRQUOj5iQkJENBlBUE+VssrCGhTrOzv3hBHBbkprq9no6SPO8NOqwa7tI2NR2m8abWPheV59wQtGnJOVt7gT7BDXLEDSOn2WbU7sZj/JPiX0elNYTiEQdvqeu7g9fohCVbQRw+A346vd44/2nvasfxCRr9dpoXGSHdfv9n0JR3OnF88vDhl+/5G7aysgz8Lxh0AAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "axure icon",
              "title": "axure icon",
              "src": "/static/e878c89184e7e02b36a7c03481bb8d0a/36382/axure-icon.png",
              "srcSet": ["/static/e878c89184e7e02b36a7c03481bb8d0a/36382/axure-icon.png 245w"],
              "sizes": "(max-width: 245px) 100vw, 245px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </ResourceCard>
      </Column>
    </Row>
    <br />
    <h2>{`Start designing`}</h2>
    <p>{`To get started, familiarize yourself with the contents of the template and widget library.`}</p>
    <h3>{`Start with the template`}</h3>
    <p>{`Create a new project document with the template by opening `}<inlineCode parentName="p">{`ibm-carbon-template.rp`}</inlineCode>{` and saving a copy.`}</p>
    <p>{`In the template, IBM Plex Sans and IBM Plex Mono are included as web fonts in the Generate HTML settings and will be displayed properly on any computer, even without these fonts being installed locally.`}</p>
    <p>{`The Default, Paragraph, and Text Link styles are pre-configured, which allows text to be pasted from the clipboard or text link inserted in a paragraph to match the typography and color guidelines by default.`}</p>
    <h3>{`Using widgets`}</h3>
    <p>{`Use the widgets from the IBM Carbon 10 Axure library installed in step two to start designing. You’ll find the widgets located in the Libraries pane in the left side panel. To add a widget to the canvas, click and drag it from the Libraries pane.`}</p>
    <p>{`All widgets come with styles and interactions already built into them. To edit the widgets, follow the guide in the `}<a parentName="p" {...{
        "href": "https://ibm.github.io/design-kit/axure/"
      }}>{`Carbon Axure Kit documentation`}</a>{` that will help you to maintain the designed behavior of the elements.`}</p>
    <h2>{`Support`}</h2>
    <p>{`If you are brand new to Axure, they offer `}<a parentName="p" {...{
        "href": "https://docs.axure.com/tutorials/basics/getting-started/"
      }}>{`tutorials`}</a>{` to get you started.`}</p>
    <h3>{`Releases`}</h3>
    <p>{`We make small adjustments and bug fixes to the kit on a regular basis. When a new version of the library is available, you need to download the new file to replace the old one. Releases will be posted to the `}<a parentName="p" {...{
        "href": "https://github.com/IBM/design-kit"
      }}>{`GitHub repo`}</a>{`.`}</p>
    <p>{`If you’re an IBMer, join the #carbon-axure-kit Slack channel to get notified about changes.`}</p>
    <h3>{`Updating existing documents`}</h3>
    <p>{`In an Axure RP document, styles already in use in the document prevail when adding widgets from a library. The existing style in the document will be applied to a library widget when the widget is dragged onto the document canvas.`}</p>
    <p>{`Replacing the library won’t update the widget styles in your existing project files automatically. Follow the manual process below to update the styles.`}</p>
    <p>{`Import the styles from the library file into project documents using the Import Wizard.`}</p>
    <ol>
      <li parentName="ol">{`Open your project in Axure RP.`}</li>
      <li parentName="ol">{`Go to `}<inlineCode parentName="li">{`File`}</inlineCode>{` → `}<inlineCode parentName="li">{`Import from RP file...`}</inlineCode>{` and select the .rplib library file.`}</li>
      <li parentName="ol">{`In the wizard, go to the Import Widget Styles step, and select all custom styles. “Default” should `}<strong parentName="li">{`not`}</strong>{` be selected.`}</li>
    </ol>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "79.46428571428572%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAAsSAAALEgHS3X78AAACu0lEQVQ4y52Uv2/TUBDHXUfIXZAYGRgK6sxQpE4IKVMRhIqFLkkrWrX5ASnqj4WJhYGq6gITSEwMTPwFKLQSC6Jq0xSHuFbS0NhxHCd1frlK4sTPxz03dWlLxY+Tvn7vne8+fnfPNsOgTQ9cYZ+O+rjo4mL/bDTKhcNhbmpqipuZmeH8fj/n8/m4kZERbmJigotEIlwoFHIVDAa52dnZ/snJSQ9zZInVTz5FEEQpr2zLkvQtn8/zVIqi8LlcjhcEgU+lUnw2m3X8siz/qgT6fvA8HzoGJhIRQGu329DpdKDb7cK/Gj5s2QVuxuOhVqsFuq53K5WKVa/XycHBAWk2m85oGIYzx7zfyaTATCbzwgXG4/EwJoKqqgTLtBEKCIVGowHUT61hGK6vWq0CjanValROOel0eskFbmxshGmZxWKRYIJNy6Y7pi1omyZYuBY0HVStBLIs0TinLTTONE0HiH0+CaRO27ZpCfaZBhECO/t1KFeqUFRV2Nd1CnKAaOcDaap9aODK8VoOUC2VoKAoTrnY16N2/BnY2+0ZYLFUBrVQcPvai/v/HVIg7V+5XHb6+1fA0z20cGVZFiTLNZBVDeS8AvgB4Kkf7tI+p+RQL79LCMF8i17otPeuWaRkNIhpVAkxdNKuas4cz5CATTo94PF7uLW19Zg6e6d2wt5nuvBW6MCbVBs+ZDvw+nsLXm03Ya1AnFJ08zBuJ7274gJjsdiYKIrZZDK5I0mSqGmaWNKKoqSo4vLarri0mhFXcHz5OSs+j2XEZx8z4rv1PTGH9zfTeWFPLclfvq7POTD8g/ThcBE1gBo8rVsoL+omahh128MM3rvADF49GYdL5tL1G8N9DnR8fLzP6/WyQ0NDnkAgwM7PL7CLc0/YQDDKMszosTz3cfSh7rDM5THWj/ev3Z1mH4QX2IfBRw7sJx8pi6XcJ+eSAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Axure wizard settings",
            "title": "Axure wizard settings",
            "src": "/static/15bcefbaa7bfee560e88e8c7b9c5cc98/3cbba/axure-updates.png",
            "srcSet": ["/static/15bcefbaa7bfee560e88e8c7b9c5cc98/7fc1e/axure-updates.png 288w", "/static/15bcefbaa7bfee560e88e8c7b9c5cc98/a5df1/axure-updates.png 576w", "/static/15bcefbaa7bfee560e88e8c7b9c5cc98/3cbba/axure-updates.png 1152w", "/static/15bcefbaa7bfee560e88e8c7b9c5cc98/11f6b/axure-updates.png 1344w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Skip to the end of the wizard and click Finish to import the styles.`}</li>
    </ol>
    <h3>{`Help`}</h3>
    <p>{`Can’t find an answer to your question? Open an issue on `}<a parentName="p" {...{
        "href": "https://github.com/IBM/design-kit/issues/new?assignees=csabasipos&labels=kit%3A+axure&template=-axure--carbon-kit.md&title=%5Bcomponent%5D+description+of+issue"
      }}>{`GitHub`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      